import React, { useState } from 'react';
import PropTypes from 'prop-types';
import HiddenIcon from '../../../assets/images/hiddenIcon.svg';
import ViewIcon from '../../../assets/images/viewIcon.svg';
import {
  DesignatedPersonWrapper,
  DesignatedPersonValue,
  RevealButton
} from './riderDesignatedPersonStyles';

// A Family Benefit rider has one CoveredPerson. The rider title is rendered
// separately; this field only renders that person's API fullName.
function RiderDesignatedPerson({ id, fieldData }, context) {
  const {
    intl: { formatMessage }
  } = context;
  const [maskingFlag, setMaskingFlag] = useState(true);

  const revealIcon = maskingFlag ? HiddenIcon : ViewIcon;

  return (
    <DesignatedPersonWrapper id={id}>
      <DesignatedPersonValue
        className={`isMask${maskingFlag}`}
        id={`${id}_value`}
        aria-hidden={maskingFlag}
      >
        {!fieldData ? (
          <span>{formatMessage({ id: 'noChildAssigned' })}</span>
        ) : (
          fieldData
        )}
      </DesignatedPersonValue>
      <RevealButton
        type="button"
        aria-pressed={!maskingFlag}
        aria-controls={`${id}_value`}
        onClick={() => setMaskingFlag(previous => !previous)}
      >
        <img src={revealIcon} alt="" aria-hidden="true" />
      </RevealButton>
    </DesignatedPersonWrapper>
  );
}

RiderDesignatedPerson.propTypes = {
  id: PropTypes.string,
  fieldData: PropTypes.string
};

RiderDesignatedPerson.defaultProps = {
  id: 'riderDesignatedPerson',
  fieldData: ''
};

RiderDesignatedPerson.contextTypes = {
  intl: PropTypes.object.isRequired
};

export default RiderDesignatedPerson;
